import { html } from '../../mixins/katapult-element.js';
import { KatapultEditorTemplate } from './katapult-editor-template.js';
import { PortalStyle } from './katapult-model-editor-style.js';
import '../paper-header/paper-header.js';
import '../katapult-dialog-legacy/katapult-dialog-legacy.js';
import '../material-icon-picker/material-icon-picker.js';
import '../katapult-drop-down/katapult-multi-drop-down.js';
import '../katapult-color-picker/katapult-color-picker-button.js';
import '../katapult-color-picker/katapult-color-picker-dialog.js';
import '../katapult-elements/katapult-button.js';

customElements.define(
  'katapult-hub-application-configuration-editor',
  class extends KatapultEditorTemplate {
    static get template() {
      return html`
        ${super.style} ${PortalStyle}
        <style>
          #iconPickerDialog {
            --katapult-dialog-legacy-body: {
              padding: 0;
              overflow: hidden;
            };
          }
        </style>

        <katapult-firebase-worker path="[[modelSpaceDetails.path]]/models/attributes" data="{{otherAttributes}}">
        </katapult-firebase-worker>

        <katapult-dialog-legacy id="iconPickerDialog" modal no-header overflow-hidden>
          <material-icon-picker slot="body"></material-icon-picker>
          <katapult-button slot="buttons" dialog-dismiss>Close</katapult-button>
        </katapult-dialog-legacy>

        <katapult-color-picker-dialog></katapult-color-picker-dialog>

        <template is="dom-repeat" items="[[steps]]" as="step">
          <katapult-editor-step
            creating-item="[[creatingItem]]"
            active="[[step.active]]"
            index="[[step.index]]"
            current-index="[[currentIndex]]"
            title="[[step.title]]"
          >
            <template is="dom-if" if="[[equal(step.id, 'companies')]]" restamp>
              <div slot="header">-</div>
              <paper-cell italic slot="header" style="text-transform:none;">[[step.subtitle]]</paper-cell>
              <paper-table light-grey rounded outline slot="body">
                <paper-row input style="height:auto;">
                  <paper-cell>
                    <katapult-multi-drop-down
                      label="Select companies"
                      no-label-float
                      items="[[getPicklists(otherAttributes.company)]]"
                      value-path="value"
                      label-path="value"
                      value="{{_itemData.companies}}"
                    ></katapult-multi-drop-down>
                  </paper-cell>
                </paper-row>
              </paper-table>
              <katapult-button style="margin-left: 16px;" on-click="nextStep" slot="current-step-body">Continue</katapult-button>
            </template>

            <template is="dom-if" if="[[equal(step.id, 'color')]]" restamp>
              <div slot="header">-</div>
              <paper-cell italic slot="header" style="text-transform:none;">[[step.subtitle]]</paper-cell>
              <paper-table light-grey rounded outline slot="body">
                <paper-row input style="height:auto;">
                  <paper-cell>
                    <katapult-color-picker-button color="{{_itemData.color}}"></katapult-color-picker-button>
                  </paper-cell>
                </paper-row>
              </paper-table>
              <katapult-button style="margin-left: 16px;" on-click="nextStep" slot="current-step-body">Continue</katapult-button>
            </template>

            <template is="dom-if" if="[[equal(step.id, 'alias_name')]]" restamp>
              <div slot="header">-</div>
              <paper-cell italic slot="header" style="text-transform:none;">[[step.subtitle]]</paper-cell>
              <paper-table light-grey rounded outline slot="body">
                <paper-row input style="height:auto;">
                  <paper-cell>
                    <paper-input label='(i.e. "APP Number")' no-label-float value="{{_itemData.alias_name}}"></paper-input>
                  </paper-cell>
                </paper-row>
              </paper-table>
              <katapult-button style="margin-left: 16px;" on-click="nextStep" slot="current-step-body">Continue</katapult-button>
            </template>

            <template is="dom-if" if="[[equal(step.id, 'sort_order')]]" restamp>
              <div slot="header">-</div>
              <paper-cell italic slot="header" style="text-transform:none;">[[step.subtitle]]</paper-cell>
              <paper-table light-grey rounded outline slot="body">
                <paper-row input style="height:auto;">
                  <paper-cell>
                    <paper-input
                      label="Enter a number to sort by"
                      no-label-float
                      type="number"
                      value="{{_itemData.sort_order}}"
                    ></paper-input>
                  </paper-cell>
                </paper-row>
              </paper-table>
              <katapult-button style="margin-left: 16px;" on-click="nextStep" slot="current-step-body">Continue</katapult-button>
            </template>

            <template is="dom-if" if="[[equal(step.id, 'app_types')]]" restamp>
              <katapult-button on-click="nextStep" slot="current-step-header">Continue</katapult-button>
              <!-- Table -->
              <paper-table rounded outline slot="body" grow overflow-hidden>
                <paper-table-scroll data-path="_itemData.app_types" on-sort-changed="orderedItemsArraySortChanged">
                  <!-- Header -->
                  <paper-row grey short slot="before">
                    <paper-cell icon>
                      <material-icon icon="swap_vert"></material-icon>
                    </paper-cell>
                    <paper-cell>App Type</paper-cell>
                    <paper-cell icon>
                      <material-icon icon="unfold_more"></material-icon>
                    </paper-cell>
                    <paper-cell icon></paper-cell>
                  </paper-row>
                  <!-- Body -->
                  <template is="dom-repeat" items="[[getOrderedItemsArray(_itemData.app_types.*)]]" mutable-data as="appType">
                    <paper-header-content
                      data-path="_itemData.app_types.$(model.appType.$key)"
                      on-opened-changed="updateProperty"
                      on-render-changed="updateProperty"
                      slot="sortable"
                      opened="[[appType.$opened]]"
                      divider
                      no-click-row
                    >
                      <paper-cell slot="header" icon drag-handle>[[add(index, 1)]]</paper-cell>
                      <paper-cell slot="header" input>
                        <paper-input
                          label="App Type Name"
                          value="[[appType.name]]"
                          data-path="_itemData.app_types.$(model.appType.$key).name"
                          no-label-float
                          on-value-changed="updateProperty"
                        ></paper-input>
                      </paper-cell>
                      <paper-cell slot="header-end" icon-button>
                        <katapult-button
                          iconOnly
                          noBorder
                          icon="delete"
                          data-path="_itemData.app_types.$(model.appType.$key)"
                          data-value="$null"
                          on-click="updateProperty"
                        ></katapult-button>
                      </paper-cell>
                      <template is="dom-if" if="[[appType.$render]]" restamp>
                        <div slot="content">
                          <paper-table>
                            <!-- Max Pole Count -->
                            <paper-row input>
                              <paper-cell icon>
                                <material-icon icon="format_list_numbered"></material-icon>
                              </paper-cell>
                              <paper-cell shrink>Max Pole Count</paper-cell>
                              <paper-cell input>
                                <paper-input
                                  type="number"
                                  label="Max Pole Count"
                                  value="[[appType.max_pole_count]]"
                                  underline
                                  no-label-float
                                  data-path="_itemData.app_types.$(model.appType.$key).max_pole_count"
                                  on-change="toggleProperty"
                                ></paper-input>
                              </paper-cell>
                            </paper-row>
                            <!-- App Status Groups -->
                            <paper-row expand>
                              <paper-cell icon>
                                <material-icon icon="group_work"></material-icon>
                              </paper-cell>
                              <paper-cell shrink>App Status Groups (optional)</paper-cell>
                              <paper-cell>
                                <!-- Table -->
                                <paper-table rounded white outline grow overflow-hidden>
                                  <paper-table-scroll
                                    data-path="_itemData.app_types.$(model.appType.$key).app_status_groups"
                                    on-sort-changed="orderedItemsArraySortChanged"
                                  >
                                    <!-- Header -->
                                    <paper-row grey short slot="before">
                                      <paper-cell icon>
                                        <material-icon icon="swap_vert"></material-icon>
                                      </paper-cell>
                                      <paper-cell>App Status Group</paper-cell>
                                      <paper-cell icon>
                                        <material-icon icon="unfold_more"></material-icon>
                                      </paper-cell>
                                      <paper-cell icon></paper-cell>
                                    </paper-row>
                                    <!-- Body -->
                                    <template is="dom-repeat" items="[[getOrderedItemsArray(appType.app_status_groups.*)]]" mutable-data>
                                      <paper-header-content
                                        data-path="_itemData.app_types.$(model.parentModel.appType.$key).app_status_groups.$(model.item.$key)"
                                        on-opened-changed="updateProperty"
                                        on-render-changed="updateProperty"
                                        slot="sortable"
                                        opened="[[item.$opened]]"
                                        divider
                                        expand
                                        no-click-row
                                      >
                                        <paper-cell slot="header" icon drag-handle>[[add(index, 1)]]</paper-cell>
                                        <paper-cell slot="header" input>
                                          <paper-input
                                            no-label-float
                                            label="App Status Group"
                                            value="[[item.name]]"
                                            data-path="_itemData.app_types.$(model.parentModel.appType.$key).app_status_groups.$(model.item.$key).name"
                                            on-value-changed="updateProperty"
                                          ></paper-input>
                                        </paper-cell>
                                        <paper-cell slot="header-end" icon-button>
                                          <katapult-button
                                            iconOnly
                                            noBorder
                                            icon="delete"
                                            data-path="_itemData.app_types.$(model.parentModel.appType.$key).app_status_groups.$(model.item.$key)"
                                            data-value="$null"
                                            on-click="updateProperty"
                                          ></katapult-button>
                                        </paper-cell>
                                        <template is="dom-if" if="[[item.$render]]" restamp>
                                          <div slot="content">
                                            <!-- Color -->
                                            <paper-row expand>
                                              <paper-cell icon>
                                                <material-icon icon="palette"></material-icon>
                                              </paper-cell>
                                              <paper-cell shrink>Color</paper-cell>
                                              <paper-cell>
                                                <katapult-color-picker-button
                                                  color="[[item.color]]"
                                                  data-path="_itemData.app_types.$(model.parentModel.appType.$key).app_status_groups.$(model.item.$key).color"
                                                  on-change="updateProperty"
                                                ></katapult-color-picker-button>
                                              </paper-cell>
                                            </paper-row>
                                            <!-- Icon -->
                                            <paper-row expand>
                                              <paper-cell icon>
                                                <material-icon icon="emoji_objects"></material-icon>
                                              </paper-cell>
                                              <paper-cell shrink>Icon</paper-cell>
                                              <template is="dom-if" if="[[item.icon]]">
                                                <paper-cell icon>
                                                  <material-icon icon="[[item.icon]]"></material-icon>
                                                </paper-cell>
                                              </template>
                                              <paper-cell buttons-container>
                                                <katapult-button
                                                  icon="cached"
                                                  size="18"
                                                  on-click="pickAnIcon"
                                                  data-path="_itemData.app_types.$(model.parentModel.appType.$key).app_status_groups.$(model.item.$key).icon"
                                                  >Change Icon</katapult-button
                                                >
                                                <template is="dom-if" if="[[item.icon]]">
                                                  <katapult-button
                                                    icon="clear"
                                                    size="18"
                                                    style="margin-left: 8px;"
                                                    on-click="updateProperty"
                                                    data-path="_itemData.app_types.$(model.parentModel.appType.$key).app_status_groups.$(model.item.$key).icon"
                                                    data-value="$null"
                                                    >Clear Icon</katapult-button
                                                  >
                                                </template>
                                              </paper-cell>
                                            </paper-row>
                                          </div>
                                        </template>
                                      </paper-header-content>
                                    </template>
                                    <!-- Add Button -->
                                    <paper-row
                                      class="addButton"
                                      ripple
                                      short
                                      slot="after"
                                      data-path="_itemData.app_types.$(model.appType.$key).app_status_groups"
                                      on-click="addOrderedItem"
                                    >
                                      <paper-cell>
                                        <material-icon icon="add_circle_outline"></material-icon>
                                        <div>Add a Group</div>
                                      </paper-cell>
                                    </paper-row>
                                  </paper-table-scroll>
                                </paper-table>
                              </paper-cell>
                            </paper-row>

                            <!-- App Statuses -->
                            <paper-row expand>
                              <paper-cell icon>
                                <material-icon icon="login"></material-icon>
                              </paper-cell>
                              <paper-cell shrink>App Statuses</paper-cell>
                              <paper-cell>
                                <!-- Table -->
                                <paper-table rounded white outline grow overflow-hidden>
                                  <paper-table-scroll
                                    data-path="_itemData.app_types.$(model.appType.$key).app_statuses"
                                    on-sort-changed="orderedItemsArraySortChanged"
                                  >
                                    <!-- Header -->
                                    <paper-row grey short slot="before">
                                      <paper-cell icon>
                                        <material-icon icon="swap_vert"></material-icon>
                                      </paper-cell>
                                      <paper-cell>App Status</paper-cell>
                                      <paper-cell icon>
                                        <material-icon icon="unfold_more"></material-icon>
                                      </paper-cell>
                                      <paper-cell icon></paper-cell>
                                    </paper-row>
                                    <!-- Body -->
                                    <template is="dom-repeat" items="[[getOrderedItemsArray(appType.app_statuses.*)]]" mutable-data>
                                      <paper-header-content
                                        data-path="_itemData.app_types.$(model.parentModel.appType.$key).app_statuses.$(model.item.$key)"
                                        on-opened-changed="updateProperty"
                                        on-render-changed="updateProperty"
                                        slot="sortable"
                                        opened="[[item.$opened]]"
                                        divider
                                        expand
                                        no-click-row
                                      >
                                        <paper-cell slot="header" icon drag-handle>[[add(index, 1)]]</paper-cell>
                                        <paper-cell slot="header" input>
                                          <paper-input
                                            no-label-float
                                            label="App Status"
                                            value="[[item.name]]"
                                            data-path="_itemData.app_types.$(model.parentModel.appType.$key).app_statuses.$(model.item.$key).name"
                                            on-value-changed="updateProperty"
                                          ></paper-input>
                                        </paper-cell>
                                        <paper-cell slot="header-end" icon-button>
                                          <katapult-button
                                            iconOnly
                                            noBorder
                                            icon="delete"
                                            data-path="_itemData.app_types.$(model.parentModel.appType.$key).app_statuses.$(model.item.$key)"
                                            data-value="$null"
                                            on-click="updateProperty"
                                          ></katapult-button>
                                        </paper-cell>
                                        <template is="dom-if" if="[[item.$render]]" restamp>
                                          <div slot="content">
                                            <!-- Color -->
                                            <paper-row expand>
                                              <paper-cell icon>
                                                <material-icon icon="palette"></material-icon>
                                              </paper-cell>
                                              <paper-cell shrink>Color</paper-cell>
                                              <paper-cell>
                                                <katapult-color-picker-button
                                                  color="[[item.color]]"
                                                  data-path="_itemData.app_types.$(model.parentModel.appType.$key).app_statuses.$(model.item.$key).color"
                                                  on-change="updateProperty"
                                                ></katapult-color-picker-button>
                                              </paper-cell>
                                            </paper-row>
                                            <!-- Icon -->
                                            <paper-row expand>
                                              <paper-cell icon>
                                                <material-icon icon="emoji_objects"></material-icon>
                                              </paper-cell>
                                              <paper-cell shrink>Icon</paper-cell>
                                              <template is="dom-if" if="[[item.icon]]">
                                                <paper-cell icon>
                                                  <material-icon icon="[[item.icon]]"></material-icon>
                                                </paper-cell>
                                              </template>
                                              <paper-cell buttons-container>
                                                <katapult-button
                                                  icon="cached"
                                                  size="18"
                                                  on-click="pickAnIcon"
                                                  data-path="_itemData.app_types.$(model.parentModel.appType.$key).app_statuses.$(model.item.$key).icon"
                                                  >Change Icon</katapult-button
                                                >
                                                <template is="dom-if" if="[[item.icon]]">
                                                  <katapult-button
                                                    icon="clear"
                                                    size="18"
                                                    style="margin-left: 8px;"
                                                    on-click="updateProperty"
                                                    data-path="_itemData.app_types.$(model.parentModel.appType.$key).app_statuses.$(model.item.$key).icon"
                                                    data-value="$null"
                                                    >Clear Icon</katapult-button
                                                  >
                                                </template>
                                              </paper-cell>
                                            </paper-row>
                                            <!-- Group -->
                                            <paper-row input>
                                              <paper-cell icon>
                                                <material-icon icon="group_work"></material-icon>
                                              </paper-cell>
                                              <paper-cell shrink>Group (optional)</paper-cell>
                                              <paper-cell>
                                                <katapult-drop-down
                                                  label="Group"
                                                  value="[[item.group]]"
                                                  items="[[appType.app_status_groups]]"
                                                  data-path="_itemData.app_types.$(model.parentModel.appType.$key).app_statuses.$(model.item.$key).group"
                                                  underline
                                                  no-label-float
                                                  on-value-changed="updateProperty"
                                                ></katapult-drop-down>
                                              </paper-cell>
                                            </paper-row>
                                          </div>
                                        </template>
                                      </paper-header-content>
                                    </template>
                                    <!-- Add Button -->
                                    <paper-row
                                      class="addButton"
                                      ripple
                                      short
                                      slot="after"
                                      data-path="_itemData.app_types.$(model.appType.$key).app_statuses"
                                      on-click="addOrderedItem"
                                    >
                                      <paper-cell>
                                        <material-icon icon="add_circle_outline"></material-icon>
                                        <div>Add a Status</div>
                                      </paper-cell>
                                    </paper-row>
                                  </paper-table-scroll>
                                </paper-table>
                              </paper-cell>
                            </paper-row>
                          </paper-table>
                        </div>
                      </template>
                    </paper-header-content>
                  </template>
                  <!-- Add Button -->
                  <paper-row
                    class="addButton"
                    ripple
                    light-grey
                    short
                    slot="after"
                    data-path="_itemData.app_types"
                    on-click="addOrderedItem"
                  >
                    <paper-cell>
                      <material-icon icon="playlist_add"></material-icon>
                      <div>Add an App Type</div>
                    </paper-cell>
                  </paper-row>
                </paper-table-scroll>
              </paper-table>
            </template>
          </katapult-editor-step>
        </template>
        ${super.createItemContainer}
      `;
    }

    ready() {
      super.ready();
      this.appConfiguration = new AppConfiguration(this);

      // An ordered list of all possible steps.
      this.setSteps([
        {
          id: 'companies',
          title: 'Companies',
          subtitle: 'Companies from the company attribute that receive these applications.'
        },
        {
          id: 'color',
          title: 'Company Color',
          subtitle: 'The brand color of this company (used for map outlines).'
        },
        {
          id: 'alias_name',
          title: 'Tracking Number',
          subtitle: 'The name of the main number used to track applications'
        },
        {
          id: 'sort_order',
          title: 'Display Order',
          subtitle: 'The order to display these applications in relation to others.'
        },
        {
          id: 'app_types',
          title: 'App Types'
        }
      ]);
    }

    getPicklists(attribute) {
      return Object.values(attribute?.picklists || {}).flat(1);
    }

    pickAnIcon(e) {
      const path = this.getDataPath(e);
      // Get a reference to the icon picker.
      const dialog = this.$.iconPickerDialog;
      const picker = dialog.querySelector('material-icon-picker');
      // Listen for one change event.
      const callback = picker.addEventListener(
        'change',
        (e) => {
          // Set the icon at the specified path.
          this.updateProperty(new CustomEvent('icon-change', { detail: { path, value: e.detail.value } }));
          // Close the dialog.
          dialog.close();
        },
        { once: true }
      );
      // Open the dialog.
      dialog.open().then(() => {
        // When the dialog closes, remove the listener (may be unecessary if listener closed the dialog).
        picker.removeEventListener('change', callback);
      });
    }
  }
);
